import { useI18n } from '#/i18n/hooks/useI18n';
import type { FlashStyle } from '#/zustand-stores/flashesStore';

import {
  FlashBarCloseButton,
  FlashBarCloseButtonHolder,
  FlashBarContainer,
  FlashBarHeadline,
} from './FlashBar.styled';
import { flashBarStyleColor } from './flashBarStyleColor';

type Props = {
  message: string;
  style: FlashStyle;
  onRemove: () => void;
};

export function FlashBar({ message, style, onRemove }: Props) {
  const { i18n } = useI18n();
  const flashTheme = flashBarStyleColor[style] || flashBarStyleColor.info;
  const closeButtonVariant =
    flashTheme.color === 'white' ? 'tertiary-white' : 'tertiary-grey';

  const closeHandler = () => {
    onRemove();
  };

  return (
    <FlashBarContainer data-qa-id="flash-message" $variant={style}>
      <FlashBarHeadline>{message}</FlashBarHeadline>
      <FlashBarCloseButtonHolder>
        <FlashBarCloseButton
          type="button"
          qaId="flash-message-close"
          onClick={closeHandler}
          aria-label={i18n('Close alert message')}
          icon={{ name: 'close' }}
          variant={closeButtonVariant}
        />
      </FlashBarCloseButtonHolder>
    </FlashBarContainer>
  );
}
